module.exports = __webpack_public_path__ + "static/media/account-creation.8726e796.svg";